import React, {useEffect} from 'react';
import {Redirect, Route, Switch, withRouter,} from 'react-router';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Auth from './scenes/auth';
import Dashboard from './scenes/dashboard';

import 'react-image-lightbox/style.css';
import './utils/Polyfills';
import Notification from "./components-new/general/Notifications";
import ChatSoundWarning from './components-new/general/ChatSoundWarning';

const App = ({language}) => {
    useEffect(() => {
        document.documentElement.setAttribute('data-locale', language === 'hy' ? 'hy' : 'en');
    }, [language]);

    return (
        <div className="app">
            <Switch>
                <Route path="/dashboard/invitation-register/:token" component={Auth}/>
                <Route path="/dashboard" component={Dashboard}/>
                <Route exact path="/" render={() => <Redirect to="/dashboard"/>}/>
                <Route exact path="/login" component={Auth}/>
                <Route exact path={"/forgot"} component={Auth}/>
                <Route path={"/reset-password/:token"} component={Auth}/>
            </Switch>
            <Notification/>
            <ChatSoundWarning/>
        </div>
    );
};

App.propTypes = {
    language: PropTypes.string,
};

App.defaultProps = {
    language: 'en',
};

const mapStateToProps = state => ({language: state.user.language});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.jsx